    // Listen for the pplrAppInitiated custom event
      window.addEventListener('pplrAppInitiated' , function(e) {
        console.log("hello M")
        setTimeout(() => {
    window.PPLR_CAlCULATE_PRICE = function (k,_l,_n) {


        if (window.pplr_addi_price) {
            pricechange = true;
          }
        
        if(!pricechange){
          return 0;
        }
        
        if(k){
          if(jQuery(_l).val()<_n){jQuery(_l).val(_n)}
        }
        var pplrqty = 0;
        var pplrqtyreturn = 0;
        var pprice2 = pplr_product.price;
        var pplrform = jQuery('.pplr_atc_form');
        var qty = 1 ;
        
        if(pplrform.find("[name='quantity']").length>0){
          qty = pplrform.find("[name='quantity']").val();
        }
        else{
          var i_d = pplrform.attr('id');
          var i_d_qty = jQuery("[name='quantity'][form='"+i_d+"']");
          if(i_d_qty[0]){
            qty = i_d_qty.val() ;
          }
        }
        
        if(window.pplr_no_qty_update){
          qty = 1;
        }
        
        var pplrvariantid = pplr_variant_id(jQuery('.pplrform,.pplr_atc_form'));
        
        
        for (var i = 0; i < pplr_product.variants.length; i++) {
          if (pplr_product.variants[i].id == pplrvariantid) {
            var pprice2 = pplr_product.variants[i].price
            }
        }
        var hasAddi = false;
        var rate = Shopify.currency.rate;
        var shopify_variant = false;
        
        if(window.pplr_variant_product){
          if(Object.keys(window.pplr_variant_product).length>0){
            shopify_variant = true;
          }
        }
        
        jQuery(".pplraddprice:not([disabled]),.pplr_disabled.pplraddprice").each(function() {
          var k= jQuery(this);
          if (jQuery.trim(k.val()) !== "" && k.val() !== "blank" && pplrischecked(k) && !k.parents('.pplr_no_preview')[0] || k.hasClass('pplr_mselect') && k.val() !== "blank" && pplrischecked(k) && !k.parents('.pplr_no_preview')[0]) {
            var dp = k.attr("data-pplr_price").replace(/[^0-9.]/g, '');
            if(dp == ''){dp = 0;}
            var a_p = parseFloat(dp);
            if(a_p>0){  
                var _J = k.attr('data-pplr_price-type');
                if(k.hasClass('pplr_font')){
                  var fr = k.data('frame');
                  var _b = jQuery('.pplr_text[data-main="' + fr + '"]');
                  var _n = _b.attr('data-pplr_price-type');
                  if (typeof _n !== typeof undefined && _n !== false) {
                    if(_n==4){k=_b;_J=_n;}
                  }
                }
                if (typeof _J !== typeof undefined && _J !== false) {
                  if(_J==3){
                    a_p = parseFloat(dp)*pprice2/10000;
                  }
        
                  if(_J==5){
                    a_p = parseFloat(dp)*pprice2/10000+parseFloat(dp)*pplrqty/100;
                  }
        
                  if(_J==4){
                    var f = k.attr("data-frame");
        
                    if (typeof pplr_price_filter == 'undefined') {
                      var pplr_price_filter = /[^0-9a-zA-Z]/g;
                    }
                    if(_PP[_CM + f].split(",")[38]>1){
                      a_p = parseFloat(dp*(k.val().replace(pplr_price_filter, '').length));
                    }
                    else{
                      a_p = parseFloat(dp*(k.val().replace(/\s/g, '').length));
                    }
        
                  }
                }
        
                if (window.pplr_modify_price) {
                  var check_p = window.pplr_modify_price(k,pplrqty,pprice2);
                  if(check_p){
                    if(check_p[0]){
                      a_p = check_p[1];
                    };
                  }
                }
        
                var cur_adjust = 0 ;
        
                var dv  = k.attr('data-variant');
        
                if (typeof dv !== typeof undefined && dv !== false && createproduct !=='2' && createproduct !=='5') {
                    if(dv ==''){
                      pplrqtyreturn = pplrqtyreturn + a_p*rate;
                    }
                    else{
                      if(diffcur){
                        var addr = Math.ceil(a_p*rate)- a_p*rate;
                        var tttr = parseFloat((pplr_product.price).toString().slice(-2));
                        var addr2 = tttr - 100;
                        if(100-addr*100-tttr>0){
                          addr2 = tttr;
                        }
                        if(_SJ2[36] !=='1'){
                          if(!shopify_variant){
                            cur_adjust = (addr2+addr*100)/(100*rate);
                            hasAddi = false;
                          }
                        }
                      }
                    }
        
                  }
                  else{
                      pplrqtyreturn += dv === '' || dv === undefined ? a_p * rate : a_p;
                  }
        
                pplrqty += dv === '' || dv === undefined ? a_p * rate : a_p;
        
        
              }
        }
        });
        
        
        if (window.pplr_addi_price) {
            pplrqty = pplrqty + window.pplr_addi_price(pplrqty,pprice2);
            pplrqtyreturn = pplrqtyreturn + window.pplr_addi_price(pplrqty,pprice2);
        }
        
        if(hasAddi && diffcur && rounding>0 && _SJ2[36] !=='1'){
        var vprice =  _SJ[26]*rate + rounding;
        var kkr = (Math.ceil(pplrqtyreturn*rate*100/vprice)*vprice-pplrqtyreturn*rate*100)/100;
        pplrqty = pplrqty + kkr/rate;
        }
        
        if(pplrqty == 0 && !pplr_calc_first){
          pplr_calc_first = true;
          return 0;
        }
        
        pplr_calc_first = true;
        
        
        var _P2 = jQuery("."+_SJ2[8]+',#'+_SJ2[8]);
        if (_CP[10] <3 ) {
        var _P = jQuery("."+_SJ2[8]+',#'+_SJ2[8]);
        
        if (!_P[0]) {var _P = jQuery("#main .ProductMeta__Price:not(.Price--compareAt),.price-list:not(.product-item__price-list) .price:not(.price--compare) ,#ProductPrice-product .money,.gf_product-price.money,#productPrice .money,.product__current-price .money,#product-price .money,.product-price .sale,.product-single .price-item--sale:visible,#price-field .money,.pplrcur,#price .price,#ProductPrice-product-template .money,.product-single__meta .product__price .price-item--sale:visible,.product__price:not(.product__price--compare)>.money,.product-detail .theme-money,.price__container .current_price .money,.price__regular .price-item--regular span,."+_SJ2[8]+',#'+_SJ2[8]);}
        if (!_P[0]) {var _P = jQuery(".product-single__price,form .price-item--regular .money,.new-price,form .price-item--regular:visible,#price,#ProductPrice-product-template,.price__container .current_price,.product__current-price,.product-price .money,.product__price.sale-price,#product-price,.product__price [data-product-price]");}
          if (!_P[0]) {var _P = jQuery(".product-single__price,form .price-item--regular,.product__price:not(.product__price--compare),.price__regular .price-item--regular");}
        }
        else{
          var _P = jQuery(".pplr-p-right .pplrcur,.pplr_ex_inner .pplrcur");
        }
        
        var _X = '';
        var _J = "$";
        var decimal = 2;
        var cur_r = false;
        
        if (_P[0]) {
            var _J = _P.attr('data-cur');
          if (typeof _J !== typeof undefined && _J !== false) {
            if (typeof pplr_money_formate !== 'undefined') {
              if(pplr_money_formate.indexOf('amount_no_decimals')> -1){
                decimal = 0;
              }
            }
          }
          else{
          if (typeof pplr_money_formate !== 'undefined') {
              if(pplr_money_formate.indexOf('amount')> -1){
              var a = pplr_money_formate.replace(/<\/?[^>]+(>|$)/g, "");
              var _J = a.split('{{')[0];
              if(a.split('}}').length>1){
                var _X = a.split('}}')[1];
              }
              if(_J.trim()==''){_P.attr('data-cur-place','right');_J = _X;cur_r = true;}
            }
        
            if(pplr_money_formate.indexOf('amount_no_decimals')> -1){
              decimal = 0;
            }
        
            }
          }
        }
        
        if( Shopify.currency !== 'undefined' && _X ==''){
        var cc = {"gbp":'£', "usd":'$', "cad":'$', "aud":'$', "eur":'€', "jpy":'¥'};
        var mc = Shopify.currency["active"].toLowerCase();
        if(cc[mc]){_J = cc[mc];}
        };
        
        var a_p_t = jQuery('.a_p_t');
        var g = 1;
        var additional = (pplrqty*qty).toFixed(decimal);
        var _w ='';
        if (_P[0] && pricechange) {
        
        var pplr_total = ((pprice2 / 100)*qty + pplrqty*qty).toFixed(decimal);
        
        var _s = jQuery(".doubly-wrapper .selected,.currency-switcher:not(.vitals-nice-select) .list .selected,.doubly-float,[name='doubly-currencies']");
        jQuery(".currency-switcher select").trigger('change');
        
        if(_s[0]){
          loadScript_pplr('//init.grizzlyapps.com/9e32c84f0db4f7b1eb40c32bdb0bdea9', function() {
              loadScript_pplr('//cdn-zeptoapps.com/product-personalizer/currency.js', function() {
                var b = Shopify.currency.active;
                if(_s.hasClass('currency-switcher-btn')){
                  var k = _s.attr('doubly-currency');
                  var _J = _s.text().split(" ")[2];
                }else{
                  if(_s.hasClass('doubly-float')){
                    var k = _s.find('.currency-switcher').val();
                    var _J = _s.attr('data-currency-symbol');
                  }else{
                    if(_s.hasClass('currency-switcher')){
                      var k = _s.val();
                      var _J = _s.find(":selected").attr('data-currency-symbol');
                    }else{
                       var k = _s.attr('data-display');
                      var _J = _s.attr('data-currency-symbol');
                    }
                  }
                }
        
                var curr = pplr_currency[k].money_with_currency_format.replace("{{amount}}",',').replace("{{ amount }}",',').replace("{{amount_with_comma_separator}}",',').replace("{{amount_no_decimals}}",',').split(',');
        
                if (typeof _J == typeof undefined || _J == false) {
                    var _J = decodeHtml(curr[0]);
                    if(pplr_currency[k].money_format.indexOf(" ")>-1){
                      _J = _J + ' ';
                    }
        
                  }
        
                _X=decodeHtml(curr[1]).replace('Ã˜Â¯.Ã˜Â¥','Ø¯.Ø¥');
        
        
                pplr_total = Currency.convert(pplr_total,Shopify.currency.active,k).toFixed(decimal);
                additional = Currency.convert(pplrqty*qty,Shopify.currency.active,k).toFixed(decimal);
                var kkr = jQuery('[doubly-currency]');
                if(kkr[0]){
                  if(kkr.first().text().indexOf(".95")>-1 || kkr.first().text().indexOf(",95")>-1){
                    if(pplr_total>0){pplr_total = pplr_total.substr(0, (pplr_total.toString().indexOf(".") + 1)) + 95;}
                    if(additional>0){additional = additional.substr(0, (additional.toString().indexOf(".") + 1)) + 95;}
                  }
                }
                _P.text(_J + numberWithCommas(pplr_total,1,pplr_currency[k].money_with_currency_format) +_X );
                if(_SJ2[6]>0){a_p_t.html('<span class="money">'+_SJ2[7]+' '+_J + numberWithCommas(additional,1,pplr_currency[k].money_with_currency_format)+_X+'</span>')}
              })
          })
        }
        else{
          //var _v=jQuery(".BOLD-mc-picker .name");if("undefined"!=typeof Currency&&"undefined"!=typeof cookieCurrency&&_v[0]){var _g=jQuery("[data-original-value]"),_c=1;if(_g[0]){var _l=parseFloat(_g.first().attr("data-original-value"))/100,_m=parseFloat(_g.first().attr("data-"+_v.first().text().toLowerCase()).replace(/[^\d.-]/g,""));_c=_l/_m}if(1==_c)var pplr_total=Currency.convert(pplr_total*_c,Shopify.currency.active,_v.first().text()).toFixed(2);else pplr_total=(pplr_total/_c).toFixed(2);_J=decodeHtml(Currency.moneyFormats[_v.first().text()].money_format.replace("{{amount}}","").replace("{{amount_no_decimals}}",""))}
          
        var _s = jQuery(".currency-picker[name='currencies'],.currency-selector select[name='currencies'],#currencies[name='currencies']");
        if(_s[0] && typeof Currency !=="undefined"  && typeof Currency.moneyFormats !=="undefined"){
            var b = Shopify.currency.active;
            if (typeof Currency.cookie === 'function') {
              var k = Currency.cookie.read();
            }
            if (k == null || typeof k !=="undefined") {
            var k = Shopify.currency.active;
            }
            k = k.toUpperCase();
            var _d = Currency.moneyFormats[k]?.["money_with_currency_format"] ??  pplr_money_formate;
        
            _d = _d.replace("<span class=money>",'').replace("</span>",'').replace("{{amount_with_comma_separator}}",',').replace("{{amount}}",',').replace("{{ amount }}",',').replace("{{amount_no_decimals}}",',').split(",") ;
        
            var _J = decodeHtml(_d[0]);
            var _w = _d[1];
            pplr_total = Currency.convert(pplr_total,Shopify.currency.active,k).toFixed(decimal);
            additional = Currency.convert(pplrqty*qty,Shopify.currency.active,k).toFixed(decimal);
            _P.text(_J + numberWithCommas(pplr_total)+_w);
        }else{
        
          pplr_total = (pplr_total*1).toFixed(decimal);
          additional = (pplrqty*1*qty).toFixed(decimal);
          _J=decodeHtml(_J).replace('&euro;','â‚¬').replace('&pound;','Â£');
          
          if(cur_r){_J='';}
          _P.text(_J + numberWithCommas(pplr_total)+_X);
        
        }    
        
          if(a_p_t[0]){a_p_t.html(_SJ2[7]+' <span>'+_J + numberWithCommas(additional)+_X+'</span></br>')}
        }
        }
    
        jQuery("#emdpr-zepto-pprice").val(pplr_total).trigger("change")
    
        if(rounding>0 && _SJ2[36] !=='1'){
        return Math.ceil(pplrqtyreturn);
        }
        else{
        
        return pplrqtyreturn;
        }
    
    
    
        }
          window.PPLR_CAlCULATE_PRICE();
          console.log(window.PPLR_CAlCULATE_PRICE)
}, 100);
            
            
          })